module.exports = __webpack_public_path__ + "static/media/default_poster.b0ba9480.gif";